import React from "react";
import { Row, Col, Button, Modal, Form, Container } from "react-bootstrap";
import t from "tcomb-form";
import "./AddDistrict.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class AddDistrict extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        districtName: "",
        states: "Select State",
        latitude: "",
        longitude: ""
      }
    };
    this.selectCategry = this.selectCategry.bind(this);
    this.onChangehandler = this.onChangehandler.bind(this);
    this.addDistrict = this.addDistrict.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  selectCategry = e => {
    this.setState({ value: { ...this.state.value, states: e.target.value } });
  };
  onChangehandler = e => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "districtName") {
      this.setState({
        value: { ...this.state.value, districtName: value }
      });
    } else if (name === "latitude") {
      this.setState({ value: { ...this.state.value, latitude: value } });
    } else if (name === "longitude") {
      this.setState({ value: { ...this.state.value, longitude: value } });
    }
  };
  addDistrict() {
    if (
      this.state.value.districtName !== "" &&
      this.state.value.states !== "Select State"
    ) {
      this.props.addDistrict(this.state.value);
      this.setState({
        value: {
          districtName: "",
          states: "Select State",
          latitude: "",
          longitude: ""
        }
      });
      this.props.handleClose();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  closeModal() {
    this.setState({
      value: {
        districtName: "",
        states: "Select State",
        latitude: "",
        longitude: ""
      }
    });
    this.props.handleClose();
  }

  render() {
    return (
      <div>
        <Modal
          show={this.props.ShowAddModel}
          onHide={this.closeModal}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>District</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Form>
                <Row>
                  <Col lg={6} md={12} sm={12} xs={12}>
                    <Container>
                      <Row>
                        <Form.Group
                          controlId="state"
                          style={{ width: "100%" }}
                        >
                          <Form.Label className="mandatoryField">State</Form.Label>
                          <div style={{ width: "100%" }}>
                            <select style={{ width: "100%" }}
                              onChange={this.selectCategry}
                              class="form-control"
                              className="districtSelect"
                            >
                              <option>Select State</option>
                              {this.props.stateList &&
                                this.props.stateList.map((item, i) => (
                                  <option key={i} value={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          controlId="latitude"
                          style={{ width: "100%" }}
                        >
                          <Form.Label>Latitude</Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="latitude"
                            value={this.state.value.latitude}
                            onChange={this.onChangehandler}
                          />
                        </Form.Group>
                      </Row>
                    </Container>
                  </Col>

                  <Col lg={6} md={12} sm={12} xs={12}>
                    <Container>
                      <Row>
                        <Form.Group controlId="name" style={{ width: "100%" }}>
                          <Form.Label className="mandatoryField">Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="districtName"
                            autoComplete="off"
                            value={this.state.value.districtName}
                            onChange={this.onChangehandler}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group controlId="longitude" style={{ width: "100%" }}>
                          <Form.Label>Longitude</Form.Label>
                          <Form.Control
                            type="text"
                            name="longitude"
                            autoComplete="off"
                            value={this.state.value.longitude}
                            onChange={this.onChangehandler}
                          />
                        </Form.Group>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button
              type="submit"
              onClick={this.addDistrict}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddDistrict;
